<template>
  <div class="customer" data-aos="fade-right" data-aos-duration="1500">
    <div class="customer-row container">
      <h1>合作过的优秀客户</h1>
      <vue-seamless-scroll
          :data="customerList"
          :class-option="classOption"
          class="warp"
      >
        <ul class="ul-item">
          <li v-for="item in customerList" :key="item.id">
            <a class="li-item"
               :style="{width: `${item.title.length * 30 + 90}` + 'px'}">
              <sup>『</sup>
              {{ item.title }}
              <sub>』</sub>
            </a>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <!--    <el-dialog :visible.sync="dialogArticleVisible">-->
    <!--      <div class="article-model">-->
    <!--        <el-empty :image-size="200" v-if="!content"></el-empty>-->
    <!--        <div  v-html='contentDetail' v-lazy-container="{ selector: 'img' }"></div>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: "Customer",
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      customerList: [],
      classOption: {
        limitMoveNum: 2,
        direction: 3,
      },
      dialogArticleVisible: false,
      content: '',
    }
  },
  computed: {
    contentDetail() {
      if (this.content) {
        return this.content.replace(/<img src/g, "<img data-src")
      } else {
        return ''
      }
    }
  },
  methods: {
    async getCustomerList() {
      let results = await this.$api.reqCustomerList()

      if (results.status === 200) {
        this.customerList = results.results
      } else {
        this.$message({showClose: true, message: "品牌数据请求失败！", type: "error"})
      }
    },

    // showContent(content) {
    //   this.dialogArticleVisible = true
    //   this.content = content
    // }
  },

  mounted() {
    this.getCustomerList()
  }
}
</script>

<style scoped lang="less">
.customer {
  margin-top: 80px;

  .customer-row {
    text-align: center;

    h1 {
      font-size: 30px;
    }

    .warp {
      width: 1200px;
      height: 85px;
      margin: 45px 0 90px 0;
      overflow: hidden;

      ul {
        list-style: none;
        padding: 0;
        margin: 0 auto;

        &.ul-item {
          display: flex;

          li {

            .li-item {
              display: block;
              height: 85px;
              margin-right: 50px;
              line-height: 72px;
              text-align: center;
              font-size: 30px;
              color: #1E55AE;
              font-family: '楷体';
              font-weight: bold;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
